/**
 * Dan ture po LOKALNOM satu.
 *
 * Analiza 2.0, 14.10.2026: dan ture se računao kao `toISOString().slice(0, 10)`,
 * a to je UTC. Između ponoći i 01–02h po našem satu UTC je još „juče", pa je
 * tura složena rano ujutru dobijala jučerašnji datum.
 */
export function lokalniDatum(d: Date): string {
  const mesec = String(d.getMonth() + 1).padStart(2, '0');
  const dan = String(d.getDate()).padStart(2, '0');

  return `${d.getFullYear()}-${mesec}-${dan}`;
}

/** Dan ture: danas, ili sutra kad se planira dan ranije. */
export function danTure(zaSutra: boolean, sad: Date = new Date()): string {
  const d = new Date(sad.getFullYear(), sad.getMonth(), sad.getDate() + (zaSutra ? 1 : 0));

  return lokalniDatum(d);
}

/** „15.10." — kratko, za naslov i naziv ture. */
export function kratkiDatum(datum: string): string {
  const [, mesec, dan] = datum.split('-');

  return `${dan}.${mesec}.`;
}
